(function () {
  // Header: mobile menu + search panel
  var header = document.querySelector('.site-header');
  if (header) {
    var menuBtn = header.querySelector('.menu-btn');
    if (menuBtn) menuBtn.addEventListener('click', function () {
      var open = header.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var searchBtn = header.querySelector('.search-btn');
    var panel = header.querySelector('.search-panel');
    if (searchBtn && panel) searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden = !panel.hidden;
      searchBtn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) panel.querySelector('input').focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (header.classList.contains('open')) { header.classList.remove('open'); menuBtn && menuBtn.setAttribute('aria-expanded', 'false'); }
      if (panel && !panel.hidden) { panel.hidden = true; searchBtn && searchBtn.setAttribute('aria-expanded', 'false'); }
    });
  }

  // Mood rail tabs: each tab shows one panel
  document.querySelectorAll('[data-moods]').forEach(function (root) {
    var tabs = root.querySelectorAll('.tabs button');
    var panels = root.querySelectorAll('.rail-panel');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart: auto-submit on quantity change
  document.querySelectorAll('form[data-cart]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('.qty input')) f.requestSubmit ? f.requestSubmit() : f.submit(); });
  });

  // Product: gallery + variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('.main-img img');
    root.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = b.dataset.src; mainImg.srcset = b.dataset.srcset || ''; mainImg.alt = b.dataset.alt || '';
        root.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    var json = root.querySelector('script[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var form = root.querySelector('form[action*="/cart/add"]');

    function selected() {
      var opts = [];
      root.querySelectorAll('.option').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.srcset = ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('.option input').forEach(function (i) { i.addEventListener('change', update); });
  });
})();
